import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const IllustrationIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 26;
  const color = props.color || 'black';
  return <Icon name={'Illustration'} size={size} color={color} />;
};

export default React.memo(IllustrationIcon);
